import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import api from '../../components/Api';

// KPI data
const initialKpiData = {
  onTimeDelivery: 95,
  postageSavings: 10000,
};

const FOOTER_LINKS = [
  'Job Submission Tips & Tricks',
  'Recent USPS News',
  'Inkjetting Tips & Tricks',
];



const handleDownload = (e, jobId, jobNum) => {
  e.stopPropagation();
  const url = `https://lightningpresort.com/uploads/files/${jobId}_${jobNum}.zip`;
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${jobId}.zip`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const Main = () => {
  const [alljobs, setAlljobs] = useState([]);
  const [expandedJob, setExpandedJob] = useState(null);

   const {authState} = useAppContext()
 
   console.log(authState)
  const nav = useNavigate();


    console.log('[Main] Render - authState:', authState);


  useEffect(() => {
    
 console.log('[Main useEffect] Fetching jobs effect triggered');
    
    if (!authState.isAuth || !authState.user) {
      console.log('[Main] User not ready, skipping API call');
      return; // wait until user exists
    }

    console.log('[Main] User ready, calling API with company id:', authState.user.company._id);

    const getjobs = async () => {
        if (!authState.isAuth || !authState.user) return; // wait until user exists
      try {
        const res = await api.post('/jobs/getopenjobs', {
          id: authState.user.company._id,
        });

        if (res.data.status === 200) {
          setAlljobs(
           res.data.message 
          );
        }
      } catch (err) {
        console.error(err);
        setAlljobs([]);
      }
    };

    getjobs();
}, [authState.isAuth, authState.user]);

  const sendToPostoffice = (e) => {
    e.stopPropagation();
    console.log('Send to Post Office');
  };

  return (
    <div className="min-h-[100dvh] flex flex-col bg-gray-100 p-2 sm:p-4">

      {/* ================= KPI CARDS ================= */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
        <div className="bg-white p-3 rounded shadow">
          <p className="text-xs font-semibold text-gray-500">Postage Savings</p>
          <p className="text-xl font-bold text-green-600">
            ${initialKpiData.postageSavings}
          </p>
        </div>

        <div className="bg-white p-3 rounded shadow">
          <p className="text-xs font-semibold text-gray-500">Pending USPS Upload</p>
          <p className="text-xl font-bold text-purple-600">3</p>
        </div>

        <div className="bg-white p-3 rounded shadow">
          <p className="text-xs font-semibold text-gray-500">Presort Pending</p>
          <p className="text-xl font-bold text-red-600">2</p>
        </div>

        <div className="hidden lg:block bg-white p-3 rounded shadow">
          <p className="text-xs font-semibold text-gray-500">On-Time Delivery</p>
          <p className="text-xl font-bold text-blue-600">
            {initialKpiData.onTimeDelivery}%
          </p>
        </div>
      </div>

      {/* ================= MOBILE JOB CARDS ================= */}
      <div className="md:hidden flex flex-col gap-3 pb-24">
        {alljobs.length === 0 && (
          <div className="bg-white rounded shadow p-4 text-sm text-gray-500">
            No active jobs found.
          </div>
        )}

        {alljobs.map((job) => {
          const open = expandedJob === job._id;

          return (
            <div key={job._id} className="bg-white rounded-lg shadow">
              <button
                onClick={() => setExpandedJob(open ? null : job._id)}
                className="w-full text-left p-4"
              >
                <div className="flex justify-between">
                  <div>
                    <p className="font-semibold text-sm">{job.jobDescription}</p>
                    <p className="text-xs text-gray-500 line-clamp-1">
                      {job.jobId}
                    </p>
                  </div>

                  <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-700">
                    {job.currentstatus}
                  </span>
                </div>

                <div className="flex justify-between mt-2 text-xs">
                  <p>
                    <span className="font-semibold">Status:</span>{' '}
                    {job.processedrecordCount || 'Pending'} / {job.recordCount}
                  </p>
                  <span className="text-blue-600">
                    {open ? 'Hide details' : 'View details'}
                  </span>
                </div>
              </button>

              {open && (
                <div className="border-t p-4 text-xs bg-gray-50 space-y-2">
                  <div className="flex justify-between">
                    <span className="font-semibold">Permit</span>
                    <span>{job.permitHolder?.permitType || '—'}</span>
                  </div>

                  {job.currentstatus === 9 && (
                    <div className="flex gap-2 pt-2">
                      <button
                        onClick={(e) =>
                          handleDownload(e, job.jobId, job.jobNum)
                        }
                        className="flex-1 bg-blue-500 text-white py-2 rounded"
                      >
                        Download ZIP
                      </button>
                      <button
                        onClick={sendToPostoffice}
                        className="flex-1 bg-blue-400 text-white py-2 rounded"
                      >
                        Send
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ================= DESKTOP TABLE ================= */}
      <div className="hidden md:block bg-white p-4 rounded shadow mt-4">
        <div className="flex justify-between mb-2">
          <h2 className="font-semibold">Active Jobs</h2>
          <button
            onClick={() => nav('/dashboard/newjob')}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            New Job
          </button>
        </div>

        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th className="p-2 text-left">Job ID</th>
              <th className="p-2 text-left">Description</th>
              <th className="p-2 text-left">Status</th>
              <th className="p-2 text-left">Permit</th>
              <th className="p-2"></th>
              <th className="p-2"></th>
            </tr>
          </thead>
          <tbody>
            {alljobs.map((job) => (
              <tr
                key={job._id}
                onClick={() => nav(`/dashboard/jobs/${job._id}`)}
                className="border-b hover:bg-gray-50 cursor-pointer"
              >
                <td className="p-2">{job.jobId}</td>
                <td className="p-2">{job.jobDescription}</td>
                <td className="p-2">
                  {job.processedrecordCount || 'Pending'} / {job.recordCount}
                </td>
                <td className="p-2">{job.permitHolder?.permitType}</td>
                <td className="p-2">
                  {job.currentstatus === 9 && (
                    <button
                      onClick={(e) =>
                        handleDownload(e, job.jobId, job.jobNum)
                      }
                      className="bg-blue-500 text-white px-3 py-1 rounded"
                    >
                      Download
                    </button>
                  )}
                </td>
                <td className="p-2">
                  {job.currentstatus === 9 && (
                    <button
                      onClick={sendToPostoffice}
                      className="bg-blue-400 text-white px-3 py-1 rounded"
                    >
                      Send
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
         {alljobs.length === 0 && (
          <div className="bg-white rounded shadow p-4 text-sm text-gray-500">
            No active jobs found.
          </div>
        )}

      </div>

      {/* ================= FOOTER ================= */}
      <footer className="mt-auto bg-gray-100 pt-4">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-2 gap-4 p-4">
          <div className="bg-white rounded shadow p-4">
            <h3 className="text-xs font-bold uppercase mb-2">Helpful Links</h3>
            {FOOTER_LINKS.map((link, i) => (
              <p key={i} className="text-xs text-gray-600 cursor-pointer">
                {link}
              </p>
            ))}
          </div>

          <div className="bg-white rounded shadow p-4">
            <h3 className="text-xs font-bold uppercase mb-2">USPS Links</h3>
            <p className="text-xs text-gray-600">
              USPS Postal Explorer<br />
              USPS Informed Delivery<br />
              USPS Mailing Standards
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Main;
